import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FiltersContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  flex-grow: 1;
  max-width: 400px;
`;

export const StyledButtonBox = styled(Box)`
  display: flex;
  align-items: end;
`;

export const ActionsContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;

export const PageContainer = styled(Box)({});
